/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useContentZoneContext } from "cms/components/context/index";
import { useUpdateComponentProperty } from "cms/components/hooks/use-update-component-property";
import { isFalse, isTrue } from "utils/empty-exists";

/**
 * @type {import('react').FC}
 */
const ComponentEditorLabel = () => {
    const { editMode } = useContentZoneContext();

    const [label, setLabel] = useUpdateComponentProperty("label");

    const onLabelChange = (event) => {
        const value = event.target.value;
        setLabel(value);
    };

    const stopPropagation = (event) => {
        event.stopPropagation();
    };

    return (
        <div>
            {isFalse(editMode) &&
                <div className='simplicity-composer-header-label'>
                    {label}
                </div>
            }
            {isTrue(editMode) &&
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <div style={{ fontWeight: "400", width: "500px" }}>
                        <TextField
                            value={label || ""}
                            placeholder='Add a label'
                            variant='standard'
                            onFocus={stopPropagation}
                            onClick={stopPropagation}
                            onChange={onLabelChange}
                            sx={{ minWidth: "400px" }}
                        />
                    </div>
                </div>
            }
        </div>
    );
};

ComponentEditorLabel.displayName = "ComponentEditorLabel";
export { ComponentEditorLabel };
